import { render, staticRenderFns } from "./uploadAgain.vue?vue&type=template&id=6ec227c2&scoped=true&"
import script from "./uploadAgain.vue?vue&type=script&lang=js&"
export * from "./uploadAgain.vue?vue&type=script&lang=js&"
import style0 from "./uploadAgain.vue?vue&type=style&index=0&id=6ec227c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec227c2",
  null
  
)

export default component.exports